import Alert from '@mui/material/Alert';

const ALERT_STYLES = {
  fontSize: '0.95rem',
  marginBottom: 10,
};

export const OrderUpdateAlert: React.FC = () => {
  return (
    <Alert severity="info" style={ALERT_STYLES}>
      O pedido foi editado. Revise os dados e confirme que está de acordo.
    </Alert>
  );
};
